import ee, { STORAGE_KEYS as s } from "./storage-manager.js";
import { logger as E } from "../../shared-lib/index.js";
var Gt = {
  La: function La(e) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var t = !1;
    try {
      if (localStorage && localStorage.getItem) try {
        localStorage.setItem(s.ct.ec, "true"), localStorage.getItem(s.ct.ec) && (localStorage.removeItem(s.ct.ec), t = !0);
      } catch (e) {
        if (!(e instanceof Error && ("QuotaExceededError" === e.name || "NS_ERROR_DOM_QUOTA_REACHED" === e.name) && localStorage.length > 0)) throw e;
        t = !0;
      }
    } catch (e) {
      E.info("Local Storage not supported!");
    }
    var r = Gt.oc(),
      a = new ee.tc(e, r && !o, t);
    var n;
    return n = t ? new ee.rc(e) : new ee.ac(), new ee(a, n);
  },
  oc: function oc() {
    return navigator.cookieEnabled || "cookie" in document && (document.cookie.length > 0 || (document.cookie = "test").indexOf.call(document.cookie, "test") > -1);
  }
};
export default Gt;